module.exports = __webpack_public_path__ + "static/media/10_plantilla_rec_combo_simple_cp_gaseosas_vidrio_350_ccso.7a2a8a20.png";